module.exports = __webpack_public_path__ + "static/media/Ubuntu Italic-01.423ce996.svg";